import { createContext, useContext } from 'react'

const ReturnToContext = createContext<string | undefined>(undefined)

export const ReturnToProvider = ReturnToContext.Provider

export function useReturnTo() {
  return useContext(ReturnToContext)
}

export function appendReturnTo(url: string, returnTo?: string): string {
  if (!returnTo) return url
  const sep = url.includes('?') ? '&' : '?'
  return `${url}${sep}return_to=${encodeURIComponent(returnTo)}`
}

export function dataWithReturnTo<T extends Record<string, any>>(data: T, returnTo?: string): T & { return_to?: string } {
  if (!returnTo) return data
  return { ...data, return_to: returnTo }
}
